import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "s-card control p-3 mb-3 container-list-inner" }
const _hoisted_2 = {
  key: `index`,
  class: "index-copy"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "icon trash" }
const _hoisted_5 = { class: "columns" }
const _hoisted_6 = { class: "column is-12" }
const _hoisted_7 = { class: "s-card" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "icon trash" }
const _hoisted_10 = { class: "delete-index" }
const _hoisted_11 = {
  key: 2,
  class: "checkbox is-outlined is-info"
}
const _hoisted_12 = ["checked", "value", "onChange"]
const _hoisted_13 = {
  key: 3,
  class: "checkbox is-outlined is-info"
}
const _hoisted_14 = ["checked", "value", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VTag = _resolveComponent("VTag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ApexChart = _resolveComponent("ApexChart")!
  const _component_VModal = _resolveComponent("VModal")!
  const _component_VButton = _resolveComponent("VButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (index) => {
        return (_openBlock(), _createElementBlock("li", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: `/stratslist/`+index.id+`/edit/`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(index.strat_name) + " ", 1),
              (_ctx.$filters.timeAgo(index.strat_name,index.created_at)<2 )
                ? (_openBlock(), _createBlock(_component_VTag, {
                    key: 0,
                    rounded: "",
                    color: "success",
                    label: "New"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["to"]),
          _createElementVNode("div", null, [
            (index.chart===true)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.getChartData(index.strat_name),index.modalChart = true),
                  class: ""
                }, [
                  _createElementVNode("span", _hoisted_4, [
                    _createVNode(_component_VModal, {
                      title: 'Chart for strategy '+index.strat_name,
                      open: index.modalChart,
                      size: "big",
                      actions: "center",
                      onClose: ($event: any) => (index.modalChart = false)
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_ApexChart, {
                                id: "apex-chart-1",
                                height: _ctx.chart_options.chart.height,
                                type: _ctx.chart_options.chart.type,
                                series: _ctx.chart_options.series,
                                options: _ctx.chart_options
                              }, null, 8, ["height", "type", "series", "options"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["title", "open", "onClose"]),
                    _cache[0] || (_cache[0] = _createElementVNode("i", {
                      "aria-hidden": "true",
                      class: "fa fa-chart-line"
                    }, null, -1))
                  ])
                ], 8, _hoisted_3))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: `/stratslist/`+index.id+`/copy/`
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "icon" }, [
                  _createElementVNode("i", { class: "fas fa-copy" })
                ], -1)
              ]))]),
              _: 1
            }, 8, ["to"]),
            (_ctx.isStaff==true || _ctx.$store.state.tabvalue=='assigned')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  onClick: ($event: any) => (index.modalDelete = true),
                  class: ""
                }, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_VModal, {
                      title: 'Delete',
                      open: index.modalDelete,
                      size: "small",
                      actions: "center",
                      onClose: ($event: any) => (index.modalDelete = false)
                    }, {
                      content: _withCtx(() => [
                        _cache[2] || (_cache[2] = _createTextVNode(" Are you sure you want to delete ", -1)),
                        _createElementVNode("b", _hoisted_10, _toDisplayString(index.strat_name), 1),
                        _cache[3] || (_cache[3] = _createTextVNode(" INDEX? ", -1))
                      ]),
                      action: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: `/stratslist/${index.id}/delete/`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_VButton, {
                              color: "primary",
                              raised: "",
                              onClick: ($event: any) => (_ctx.delStrategy(index))
                            }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode("DELETE", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1032, ["open", "onClose"]),
                    _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-trash" }, null, -1))
                  ])
                ], 8, _hoisted_8))
              : _createCommentVNode("", true),
            (_ctx.isStaff==true)
              ? (_openBlock(), _createElementBlock("label", _hoisted_11, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: index.chart,
                    value: index.chart,
                    onChange: ($event: any) => (_ctx.updateIsChart($event.target.checked, index.id, _ctx.$store.state.tabvalue))
                  }, null, 40, _hoisted_12),
                  _cache[6] || (_cache[6] = _createElementVNode("span", null, null, -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.isStaff==false && _ctx.$store.state.tabvalue=='assigned')
              ? (_openBlock(), _createElementBlock("label", _hoisted_13, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: index.chart,
                    value: index.chart,
                    onChange: ($event: any) => (_ctx.updateIsChart($event.target.checked, index.id, _ctx.$store.state.tabvalue))
                  }, null, 40, _hoisted_14),
                  _cache[7] || (_cache[7] = _createElementVNode("span", null, null, -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}